import anime from 'animejs/lib/anime.es.js';


const MenuPageAnime = () => {
	const mobileMedia = '(max-width: 799px)';
	const isSmallScreenMediaQuery = window.matchMedia(mobileMedia);
	let isSmallScreen = isSmallScreenMediaQuery.matches;

	window.addEventListener('resize', () => {
		isSmallScreen = isSmallScreenMediaQuery.matches;
	});

	const tl = anime.timeline({
		easing: 'easeInOutExpo',
		duration: 500,
	});

	tl.add({
		targets: '.tos-menu',
		opacity: [0, 1],
	});

	if (!isSmallScreen) {
		tl.add({
			targets: '.tos-menu__lists li .tos-menu__lists-button',
			opacity: [0, 1],
			delay: anime.stagger(
				200,
				{ grid: [12, 4], from: 'center' },
				{ direction: 'reverse' },
			),
			easing: 'easeOutQuad',
		});

		tl.add(
			{
				targets: '.tos-menu__largeBlock',
				opacity: [0, 1],
				duration: 1000,
			},
			'-=750',
		);

		tl.add({
			targets: '.tos-menu__largeBlock h2',
			opacity: [0, 1],
			duration: 1000,
		});

		tl.add({
			targets: '.tos-menu__largeBlock p',
			opacity: [0, 1],
			duration: 1000,
		});

		tl.add({
			targets: '.tos-menu__largeBlock small',
			opacity: [0, 1],
			duration: 1000,
		});

		tl.add(
			{
				targets: '.tos-menu__smallBlock',
				opacity: [0, 1],
				duration: 1000,
			},
			'-=4000',
		);

		tl.add({
			targets: '.tos-menu__smallBlock h2',
			opacity: [0, 1],
			duration: 1000,
		});
	} else {
		Array.from(document.querySelector('.tos-menu__content').children).forEach(
			element => {
				if (element) {
					tl.add({
						targets: element,
						opacity: [0, 1],
						duration: 1500,
					});
				}
			},
		);

		tl.add({
			targets: '.tos-menu__slider-wrapper',
			opacity: [0, 1],
			translateX: [-100, 0],
		});

		tl.add({
			targets: '#tos-menu__slider-prev',
			opacity: [0, 1],
			translateX: [-100, 0],
		});

		tl.add(
			{
				targets: '#tos-menu__slider-next',
				opacity: [0, 1],
				translateX: [100, 0],
			},
			'-=500',
		);

		tl.add(
			{
				targets: '.tos-menu__slider-pagination',
				opacity: [0, 1],
			},
			'-=500',
		);
	}
};

export default MenuPageAnime;
